import React, { forwardRef, useState } from 'react';
import CategoriesSelectBox from '../CategoriesSelectBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const BlogFillers = forwardRef(
    (
        {
            categoryOptions,
            onCategorySelect,
            selectedCategory,
            onFiltersReset,
            searchText,
            onSearchTextChange,
        },
        ref
    ) => {
        return (
            <section
                className="flex py-6 md:pt-16 md:pb-8 flex-col md:flex-row md:justify-start md:items-center gap-y-4 md:gap-x-8 xl:gap-x-4"
                ref={ref}
            >
                <div className='w-full xl:w-334'>
                    <CategoriesSelectBox
                        cssClassName="flex-auto border border-gray-300 rounded-3xl px-2 bg-basicWhite p4-regular"
                        options={categoryOptions}
                        onChange={onCategorySelect}
                        defaultValue={selectedCategory || categoryOptions[0]}
                    />
                </div>
                <div className='w-full xl:w-334'>
                    <section
                        className={
                            'w-full border border-gray-300 rounded-3xl bg-basicWhite px-4'
                        }
                    >
                        <div className={`w-full flex`}>
                            <input
                                className={`py-1 px-0 border-0 w-full h-10 outline-none focus:ring-0 p4-regular`}
                                placeholder="Search"
                                onChange={onSearchTextChange}
                                value={searchText}
                            />
                            {searchText && (
                                <button type="button" onClick={onFiltersReset}>
                                    <FontAwesomeIcon
                                        className="w-16 text-basicBlack mr-3 hover:text-basicBlack"
                                        icon="times"
                                    />
                                </button>
                            )}
                            <button className="cursor-default">
                                <FontAwesomeIcon
                                    className=" text-basicBlack hover:text-basicBlack"
                                    icon="search"
                                />
                            </button>
                        </div>
                    </section>
                </div>
            </section>
        );
    }
);

export default BlogFillers;
